module.exports = __webpack_public_path__ + "static/media/snowmobile.ea0fe939.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/snowmobile.svg
// module id = 535
// module chunks = 0